import React from 'react';

/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  cmFTH,
  a,
  gs,
  ls,
//  BarC,
  useNgnz,
  BoxC,
  GridC,
  RootC,
  SprC,
  SrlC,
  TextC,
  _cv_31___Mz
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as SprC from "./_ccbSprC";
import * as SrlC from "./_ccbSrlC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as RootC from "./_ccmRootC";
import * as _cm from './_cm';
import * as _cmFTH from './_cmFTH';
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useNgnz } from "./_csNgn";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';

//import * as icvI11___Mz from './icvI11___Mz';

import * as icm from './icm';
import * as icv from './icv';

import * as ihdI11 from './ihdI11';

import FtrC from './IccvFtr';

//import * as icvI10___Mz from './icvI10___Mz';

const _rowCnt = 8; // 一画面あたりの表示行数

let $i11rs = [] as ht.ls;

let $role = 's';
let $ctt = 'r';

export const N = (pz: {
}) => {

  const _gUserz = gs.useUserz();
  const _gStgz = gs.useStgz();

  const _udtThis = ls.udtThis();

  const _sNgnz = useNgnz();

  React.useEffect(() => {
    _sNgnz.getPmrzAsync()
    .then(async (_pmrz: ht.dz) => {
      $ctt = _pmrz.c ?? 'r';
      $role = _pmrz.r ?? 's';
      const _dmn = Number(hf.cvtNbr('d', _pmrz.d ?? '', icv.srtz.nbrz4));
      const _31r_icn = Number(hf.cvtNbr('d', _pmrz.i ?? '', icv.srtz.nbrz4));
      _gUserz.set({
        _dmn: _dmn,
      });
      const _31z = await _cv_31___Mz.load_31rDzAsync({
        _31r_icn: _31r_icn,
      })
      _gUserz.set({
        _31rz: _31z._31rz,
      });
      await icm.setStgzAsync({
        _31r_fst: _31z._31rz?._fst,
      });

//      $i11rs = await icvI11___Mz.loadI11rLsAsync({
//        _31r_fst: _31z._31rz?._fst,
//        i1zrd3100s: hfDTM.getTdy(),
//        //i1zrd3100s: '2024-02-09', -- テスト用
//        i10rt1100i: 10, // 単体部屋のみ
//        i1zrs1100iMnm: 80, // 仮予約・本予約のみ
//        lwrType: 1,
//      })

      $i11rs = await _cmFTH.loadLsAsync(ihdI11.grtQryLoadI11rLsAsync(_cm.grtUz(), {
        _31r_fst: _31z._31rz?._fst,
        i1zrd3100s: hfDTM.getTdy(),
        //i1zrd3100s: '2024-02-09', -- テスト用
        i10rt1100i: 10, // 単体部屋のみ
        i1zrs1100iMnm: 80, // 仮予約・本予約のみ
        lwrType: 1,
      }));

      _udtThis();
    })
  }, [
  ]);

  const _alls = [] as ht.ls;

  $i11rs.map((_i11rz: ht.dz) => {

    let _ls = [] as ht.ls;

    _i11rz.cldz.i10rs.map((_i10rz: ht.dz, _idx: ht.n) => {
      if ( _idx % _rowCnt == 0 ) {
        if ( _idx > 0 ) {
          _alls.push(_ls);
          _ls = [] as ht.ls;
        }
        const _cellHdrCs = [] as ht.ls;
          _cellHdrCs.push(
            {
              oClds: [
                cr.c(TextC.N, {
                  key: -10,
                  abtType: 'dntSngHdrz',
                  textz: {
                    pfx: ' ',
                  }
                })
              ]
            }
          );
        _i11rz.cldz.i111s.map((_i111z: ht.dz) => {
          _cellHdrCs.push(
            {
              oClds: [
                cr.c(TextC.N, {
                  key: -10,
                  abtType: 'dntSngHdrz',
                  textz: {
                    pfx: _i111z._pfx,
                  }
                })
              ]
            }
          );
        })
        _ls.push({
          boxStlz: a('dh/15 f/n'), // 見出しは高さ固定
          cellCs: _cellHdrCs,
        })
      }
      const _cellBdyCs = [] as ht.ls;
      _cellBdyCs.push(
        {
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'dntSngBdyz',
              textz: {
                pfx: _i10rz._pfx,
              }
            })
          ]
        }
      );

      _i10rz.cldz.i111s.map((_i111z: ht.dz) => {
        const _i1z1z = hf.get1(_i111z?.cldz?.i1z1s, {});
        const _i1zrz = hf.get1(_i1z1z?.cldz?.i1zrs, {});
        const _i18rz = hf.get1(_i1zrz?.cldz?.i18rs, {});
        if (_i18rz) {
          _cellBdyCs.push(
            {
              oClds: [
                cr.c(TextC.N, {
                  key: -10,
                  abtType: 'dntSngBdyz',
                  textz: {
                    pfx: _i18rz._pfx,
                  }
                })
              ]
            }
          );
        }
        else {
          _cellBdyCs.push(
            {
              oClds: [
              ]
            }
          );
        }
      })

      _ls.push({
        cellCs: _cellBdyCs,
      })

    });

    if (hf.f(_ls)) {
      _alls.push(_ls);
    }

  });

  //hf.l(`icvI1zS20Rz 157: ${_alls.length}`)

  const _clds = [] as ht.ls;
  _alls.map( ( _ls: ht.ls, _nIdx: ht.n ) => {
    _clds.push(
      cr.c(BoxC.N, {
        key: _nIdx,
        abtType: 'dntSngz',
        oClds: [
          cr.c(GridC.N, {
            key: -20,
            abtType: 'dntSngz',
            lineCs: _ls,
          }),
        ]
      })
    )
  });
  String(_gStgz.crt.S05031212).split('\n').filter((_url: ht.s) => hf.f(_url)).map((_url: ht.s) => {
    _clds.push(
      cr.c('iframe', {
        key: -10,
        //src: 'https://unitybell.co.jp/tmp/2211fspr/230127/210-01.pptx',
        //src: 'http://118.27.15.97:3014/static/サンプルPDF_20231212a.pdf#toolbar=0&navpanes=0&view=fitV',
        src: `${_url}#toolbar=0&navpanes=0&view=fitV`,
        height: '100%',
        width: '100%',
      })
    )
  });

  return (

    cr.c(RootC.N, {
      key: -10,
      abtType: 'dtpCmnz',
      bdyCz: {

        oClds: [

          cr.c(TextC.N, {
            key: -10,
            boxStlz: a(`dw/f fd/rcc sc/bl7`),
            textz: {
              pfx: `${_gUserz.crt._31rz?._pfx ?? ''}　${hfDTM.f(hfDTM.getTdy(), '年月日（曜日）')}${hfDTM.f(hfDTM.getNow(), '時分')}　本日の使用状況`,
              stlz: a(`tb tc/lt1 ts/4`),
            }
          }),

          cr.c(SrlC.M, {
            key: -20,
            boxStlz: a('sc/bl3'),
            cz: {
              spd: 3,
              wait: 3000,
            },
            oClds: [
              cr.c(TextC.N, {
                key: -10,
                textz: {
                  pfx: _gStgz.crt.S05031111 ?? '',
                  stlz: a('tb ts/xxl'),
                }
              })
            ]
          }),

          cr.c(SprC.N, {
            key: -30,
            boxStlz: a('f/1'),
            cz: {
              bCrl: false,
              nPrd: 5,
            },
            oClds: _clds
          }),

          cr.c(FtrC, {
            key: -40,
          })
        ],
      },
    })
  );
};

